/**
 * TourStartButton - a small "Guided tour" button for apps without a Help
 * module (the panels' top bars). Runs the first tour for the person's roles;
 * renders nothing when there is none.
 */
import { useGuidedTour } from './GuidedTourProvider';

export function TourStartButton({ className, label = 'Guided tour' }: { className?: string; label?: string }): JSX.Element | null {
  const { tours, start, activeTourId } = useGuidedTour();
  const first = tours[0];
  if (!first) return null;
  return (
    <button type="button" className={className} data-tour="tour-start" disabled={activeTourId !== null}
      title={`${first.title} - ${first.steps.length} steps`} onClick={() => start(first.id)}>
      {label}
    </button>
  );
}

export default TourStartButton;
